import axios from 'axios';
import AppConfig from "../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    getRozklad(idPrWyj, idPrDoc, data, godzina) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/rozklad' + AppConfig.V_LOG(),
            data: {
                "data": data,
                "godz": godzina,
                "idPrDo": idPrDoc,
                "idPrOd": idPrWyj
            }
        });
    },

    postBilety(data, klient) {
        if (klient === 1) {
            return axios({
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                url: URL + 'client/api/bilety' + AppConfig.V_LOG(),
                data: data
            });
        } else {
            return axios({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass)
                },
                url: URL + 'client/api/auth/bilety/jednorazowe' + AppConfig.V_LOG(),
                data: data
            });
        }
    },

    goPlatnosci(email, transakcja, kwota, nazwisko, telefon) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/platnosci/getPaymentUrl?typ=JEDNORAZOWE' + AppConfig.V_LOG_SECOND_PARAM(),
            data: {
                "email": email,
                "transakcja": transakcja,
                "kwota": kwota,
                "nazwisko": nazwisko,
                "opis": "ZAKUP BILETÓW MARCEL - ID: " + transakcja,
                "telefon": telefon
            }
        });
    },

    goPlatnosciMiesieczne(email, transakcja, kwota, nazwisko, telefon) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/platnosci/getPaymentUrl?typ=MIESIECZNE' + AppConfig.V_LOG_SECOND_PARAM(),
            data: {
                "email": email,
                "transakcja": transakcja,
                "kwota": kwota,
                "nazwisko": nazwisko,
                "opis": "ZAKUP BILETÓW MARCEL - ID: " + transakcja,
                "telefon": telefon
            }
        });
    },

    getTransakcja(transakcja) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/bilety/byTransakcja/' + transakcja + AppConfig.V_LOG(),
        });
    },

    putAnulujTransakcje(idBi, transakcja) {
        return axios({
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/bilety/anuluj/' + idBi + '/' + transakcja + AppConfig.V_LOG(),
        });
    },

    getPotwierdzenie(transakcja) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/bilety/wyslijPotwierdzenie/' + transakcja + AppConfig.V_LOG(),
        });
    },

    getDokumentyBiletu(idBi) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/faktury/daneDokumentow/biletJednorazowy/' + idBi + AppConfig.V_LOG(),
        });
    },

    getFirma(nip) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/firmy/search?nazwaOrNip=' + nip + AppConfig.V_LOG_SECOND_PARAM(),
        });
    },

    addFirma(data) {
        return axios({
            method: 'post',
            url: URL + 'client/api/firmy' + AppConfig.V_LOG(),
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
        })
    },

    editFirma(id, data) {
        return axios(
            {
                url: URL + 'client/api/firmy/' + id + AppConfig.V_LOG(),
                method: 'put',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        )
    },

    postZamianaNaFaktura(fsymNum, idBi, idFi, tabF) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/faktury/zamPGtoFK?download=true' + AppConfig.V_LOG_SECOND_PARAM(),
            data: {
                "fsymNum": fsymNum,
                "idBi": idBi,
                "idFi": idFi,
                "tabF": tabF
            }
        });
    },

    getFaktura(idBi, tabF, fSymNum) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/faktury/generujFakture/biletJednorazowy/' + idBi + '/' + tabF + '/' + fSymNum + AppConfig.V_LOG(),
        });
    },

    getPotwierdzeniePrzejazdu(idParagonu) {
        return axios({
            method: 'POST',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/bilety/getpdf/anonimowy'+ AppConfig.V_LOG(),
            data: {
                "kod": idParagonu
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/components/koszyk/KoszykService.js